var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartCrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0667 15.2669C66.3944 13.5888 64.4074 12.2573 62.2194 11.3488C60.0315 10.4403 57.6858 9.97266 55.3167 9.97266C52.9477 9.97266 50.6019 10.4403 48.414 11.3488C46.226 12.2573 44.239 13.5888 42.5667 15.2669L40 17.8669L37.4334 15.2669C35.7611 13.5888 33.774 12.2573 31.5861 11.3488C29.3982 10.4403 27.0524 9.97266 24.6834 9.97266C22.3143 9.97266 19.9686 10.4403 17.7806 11.3488C15.5927 12.2573 13.6056 13.5888 11.9334 15.2669C4.86671 22.3335 4.43338 34.2669 13.3334 43.3335L40 70.0002L66.6667 43.3335C75.5667 34.2669 75.1334 22.3335 68.0667 15.2669Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 43.3323L36.6666 39.999L43.3333 33.3323L33.3333 24.999L42.5666 15.2656",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCrack);
export default __webpack_public_path__ + "static/media/heart-crack.d6758093b31255e55a6742fb2ffe929c.svg";
export { ForwardRef as ReactComponent };